import { gql } from '@apollo/client';

export const userLeftTheAppSubscription = gql`
  subscription userLeftTheApp {
    userLeftTheApp {
      id
    }
  }
`;
